"use client"

import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

const Projects = dynamic(() => import('../components/projects'), {
  ssr: false,
  loading: () => <div className="h-96 animate-pulse bg-gray-100/50 rounded-xl" />,
})
const InnovationLabs = dynamic(() => import('../components/my-solutions'), {
  ssr: false,
  loading: () => (
    <div className="w-full h-96 bg-slate-900/10 border border-slate-800 rounded-xl animate-pulse flex items-center justify-center font-mono text-xs text-slate-500">
      Initializing Lab Protocols...
    </div>
  ),
})

export default function ClientHome() {
  const [mountProjects, setMountProjects] = useState(false)

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setMountProjects(true)
    }, 900)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [])

  return (
    <>
      <InnovationLabs />
      {mountProjects ? (
        <Projects />
      ) : (
        <div className="h-96 animate-pulse bg-gray-100/50 rounded-xl" />
      )}
    </>
  )
}
